import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { File } from '../models/file';

@Injectable()
export class FileService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  getFileUploadUrl(): string {
    const url = `${environment.surveyApiHost}/api/v1/files/upload/`;
    return url;
  }

  // fetch from the server all files uploaded by the current user
  getFiles(): Observable<File[]> {
    const get_url = `${environment.surveyApiHost}/api/v1/files/`;

    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: any) => {
        const json = response;
        return json;
      })
      .catch(this.handleError);
  }

  getFile(file_id: number): Observable<File[]> {
    const get_url = `${environment.surveyApiHost}/api/v1/files/${file_id}/`;

    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: any) => {
        const json = response;
        return json;
      })
      .catch(this.handleError);
  }

  deleteFile(file: File): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/files/${file.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  private handleError(error: any | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
